<template lang="pug">
    .actionmenu-area.d-flex.align-center
        template(
            v-for="(item, idx) in menuItems"
        )
            div
                v-btn(
                    flat
                    :color="menuBtnColor(item)"
                    :flat="menuBtnFlat(item)"
                    :key="idx"
                    @click="handleClick(item, idx)"
                    block
                    )
                    span.mr-1 ({{item.shortcut}})
                    span {{item.entry}}
                .children-menu(
                    v-if="item.children && activeMenu === idx"
                    )
                    v-btn.menu-btn(
                        :color="colors.primary"
                        v-for="(children, j) in item.children"
                        large
                        @click="handleChildrenClick(children, idx)"
                        )
                        span {{children.entry}}
</template>

<script>
import menu from './menu.js'
import ResponsiveUtils from '@/mixins/ResponsiveUtils'
import KeyBinds from '@/mixins/KeyBinds'
import { mapState } from 'vuex'
/**
 * Menu component for accessing the diferent subviews routes
 */
export default {
    name: 'actions-menu',
    props: {},

    data: function() {
        return {
            /**
             * @description
             * Returns items for the menu loaded from ./menu.js
             * Items entry follow this format:
             * @example
             *  {
             *      entry: 'Promos',
             *      shortcut: 'F4',
             *      route: 'promos'
             *  }
             */
            menuItems: menu,
            activeMenu: null,
            bindings: {
                f1: () => {
                    let route = '/'
                    this.$router.replace(route)
                },
                f2: () => {
                    let route = 'movement'
                    this.$router.replace(route)
                },
                f3: () => {
                    let route = 'arqueo'
                    this.$router.replace(route)
                },
                f5: () => {
                    let route = 'close'
                    this.$router.replace(route)
                },
                f4: () => {
                    let route = 'nota_credito'
                    this.$router.replace(route)
                },
                f6: () => {
                    if (document.activeElement.id === 'sale-ticket-input') {
                        this.$nextTick(() => {
                            document
                                .getElementById('barcode-scanner-input')
                                .focus()
                        })
                    }
                    document.getElementById('sale-ticket-input').focus()
                },
                f7: () => {
                    this.$nextTick(() =>
                        document
                            .getElementById('payment-method-control')
                            .focus()
                    )

                    // if(document.activeElement.id === 'sale-ticket-input'){
                    //     this.$nextTick(() => {
                    //         document.getElementById('barcode-scanner-input').focus()
                    //     })
                    // }
                    // document.getElementById('sale-ticket-input').blur()
                    // document.getElementById('payment-method-control').focus()
                    // // document.getElementById('payment-method').focus()
                },
                f8: () => {
                    if (this.$route.path !== '/') return
                    document.getElementById('btn-confirm-sale').click()
                },
                f9: () => {
                    this.toggleMenu(1)
                },
                f10: () => {
                    this.toggleMenu(2)
                },
            },
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            payer: 'payer',
        }),
        colorPayer: function() {
            if (this.payer == 'SE') {
                return this.colors.saleEmployeeSecundary
            } else {
                return this.colors.secondary
            }
        },
    },
    methods: {
        menuBtnColor(item) {
            // console.log(this.$route.path)
            // return this.colors.secondary
            let slash = ''
            if (item.route != '/') {
                slash = '/'
            }
            return this.$route.path != `${slash}${item.route}`
                ? null
                : this.colorPayer
            //return this.$route.path != item.route ? null : this.colors.secondary
        },

        menuBtnFlat(item) {
            let slash = ''
            if (item.route != '/') {
                slash = '/'
            }
            return this.$route.path != `${slash}${item.route}`
        },
        toggleMenu(idx) {
            if (this.activeMenu === idx) {
                this.activeMenu = null
            } else {
                this.activeMenu = idx
            }
        },
        handleClick(item, idx) {
            if (item.children) {
                this.toggleMenu(idx)
            } else {
                this.$router.replace({ path: item.route })
            }
        },
        handleBlur(idx) {
            this.toggleMenu(null)
        },
        handleChildrenClick(children, idx) {
            this.$router.replace({ path: children.route })
            this.toggleMenu(null)
        },
    },
    watch: {},
    components: {},
    mixins: [KeyBinds, ResponsiveUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.actionmenu-area {
    width: 100%;
    z-index: 9999 !important;
}
@media screen and (max-width: 959px) {
    .actionmenu-area {
        justify-content: center;
        margin-right: -2%;
    }
}

.children-menu {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    z-index: 9999 !important;
    height: 20px;
    width: 200px;
    .menu-btn {
        margin: 0px;
        border-radius: 0px;
        width: 100% !important;
    }
}
</style>
